<template>
	<v-row class="px-2">
		<v-card elevation="5" class="mt-3">
			<v-col cols="12" class="font-type text-left headline">
				Control de capacitación y difusión
			</v-col>
			<v-col cols="12">
				<form-publications />
			</v-col>
			<v-col cols="12" sm="6" md="4">
				<v-menu v-model="menu" :close-on-content-click="false" max-width="290">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							clearable
							dense
							outlined
							filled
							label="Seleccione un mes"
							readonly
							color="gray darken-2"
							v-bind="attrs"
							v-on="on"
							@click:clear="month = null"
							hide-details
							:value="dateFormatted"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="month"
						@change="menu = false"
						no-title
						type="month"
						locale="es"
					></v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="6" md="4">
				<v-text-field
					dense
					hide-details
					label="Nombres o fechas"
					outlined
					filled
					color="gray darken-2"
					append-icon="mdi-magnify"
					single-line
					v-model="search"
				></v-text-field>
			</v-col>

			<v-col cols="12" class="overflow-y-auto overflow-x-auto">
				<v-list two-line color="transparent">
					<v-subheader class="text-left font-weight-bold">
						Resumen de lecturas
					</v-subheader>
					<template v-if="publicationsSimple.length">
						<v-list-item
							style="min-height: 0px !important;"
							class="publications"
							v-for="(publication, i) in publicationsSimple"
							:key="i"
							:href="publication.url"
							target="_blank"
						>
							<v-icon color="grey darken-2" small left>mdi-eye</v-icon>
							<span class=" info--text text-uppercase font-weight-bold caption">
								<span class="grey--text darken-1">{{ publication.name }}</span>
								Visto por {{ publication.count }} personas
							</span>
						</v-list-item>
					</template>
					<data-empty
						v-else
						:title="'Sin lecturas'"
						height="20"
						no-gutters
						:msj="`Ingrese lecturas para sus trabajadores para habilitar módulo.`"
					/>
				</v-list>
			</v-col>
			<v-col cols="12" class="pt-0 pb-16">
				<div class="mt-2  ">
					<v-simple-table style="background-color: transparent;">
						<template v-slot:default>
							<thead>
								<tr>
									<th v-for="(header, i) in headers" :key="i" class="text-left">
										{{ header }}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, k) in publications" :key="k">
									<td class="text-left" style="min-width: 200px;">
										<span class="text-capitalize caption">
											{{ item.person.firstName }}
											{{ item.person.lastName }}
										</span>
									</td>
									<td class="text-left" style="min-width: 200px;">
										<span class="text-capitalize caption">
											<span class="text-capitalize">
												{{ item.name }}
											</span>
										</span>
									</td>
									<td class="text-left" style="min-width: 160px;">
										<span class="text-capitalize caption">
											{{ dateTime(item.date) }}
										</span>
									</td>
									<td class="text-left" style="min-width: 150px;">
										<span
											v-if="item.dateEndingPublications"
											class="text-capitalize caption"
										>
											{{ dateTime(item.dateEndingPublications) }}
										</span>
										<span v-else class="caption text--secondaru">
											No disponible
										</span>
									</td>
									<td class="text-left" style="min-width: 200px;">
										<span v-if="item.seen" class="caption">
											{{ dateTime(item.dateSeen) }}
											{{ getTotalVisibilityTime(item.visibilityTime) }}/{{
												item.minTimeReading
											}}
											Min
										</span>
										<span v-else class="caption">
											No 0/{{ item.minTimeReading }}Min
										</span>
									</td>
									<td class="text-left">
										<v-btn
											color="error"
											icon
											x-small
											fab
											@click="deletePublication(item.person._id, item._id)"
										>
											<v-icon>
												mdi-delete
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
			</v-col>
		</v-card>
	</v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { mapActions } from 'vuex';
let moment = extendMoment(Moment);

export default {
	props: {
		setPersonsId: { type: Function },
	},
	components: {
		FormPublications: () => import('@/components/persons/FormPublications'),
		DataEmpty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			headers: ['Persona', 'Publicacion', 'Publicado', 'Finaliza', 'Visto', 'Accion'],
			dialog: false,
			position: null,
			search: '',
			menu: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
		};
	},
	computed: {
		publications() {
			if (this.person && !this.person.publications) return [];
			return this.persons
				.flatMap(person => person.publications.map(pub => ({ ...pub, person })))
				.filter(pub => {
					if (this.search) {
						let date = moment(pub.date).format('DD-MM-YYYY');
						return (
							pub.person.firstName.toLowerCase().indexOf(this.search.toLowerCase()) >
								-1 ||
							pub.person.lastName.toLowerCase().indexOf(this.search.toLowerCase()) >
								-1 ||
							date.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
							pub.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
						);
					}
					return moment(pub.date).isSame(moment(this.month), 'month');
				})
				.sort((a, b) => {
					const da = new Date(a.date).getTime();
					const db = new Date(b.date).getTime();
					return db < da ? -1 : db > da ? 1 : 0;
				});
		},
		// publicaciones sin duplicar y un contador de cuantas veces
		publicationsSimple() {
			const items = [];
			this.publications.forEach(item => {
				if (items.some(el => el.url === item.url)) {
					const index = items.findIndex(element => element.url === item.url);
					items[index] = { ...item, count: items[index].count + item.seen ? 1 : 0 };
				} else items.push({ ...item, count: item.seen ? 1 : 0 });
			});
			return items;
		},
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		...mapGetters({
			persons: 'Person/persons',
		}),
	},
	methods: {
		getTotalVisibilityTime(time) {
			return Math.floor(time / 60);
		},
		durations(start, end) {
			if (end) {
				const diff = moment(end).diff(moment(start));
				return moment.utc(diff).format('HH:mm:ss');
			}
			return '-';
		},
		dateTime(item) {
			return moment(item).format('DD/MM/YYYY HH:mm');
		},
		formatDate(date) {
			if (date) return moment(date).format('LT');
			else return '-';
		},
		formatPublicationDate(publication) {
			return moment(publication.updatedAt).format('DD-MM-YY HH:mm');
		},
		close() {
			this.position = null;
			this.dialog = false;
		},
		getPerson(id) {
			return this.persons.find(person => person._id == id);
		},
		async deletePublication(personId, id) {
			await this.deletePublicationById({ personId, id });
		},
		...mapActions({
			deletePublicationById: 'Person/deletePublication',
		}),
	},
};
</script>

<style lang="scss" scoped>
table tbody {
	display: block;
	max-height: 300px;
	overflow-y: scroll;
}

table thead,
table tbody tr {
	display: table;
	width: 100%;
	min-width: 1200px;
	table-layout: fixed;
}
.publications {
	text-align: left;
	font-size: 12px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
	height: 30px !important;
}
</style>
